export default {
    basePath: process.env.VUE_APP_API_URL,
    perPage: 25,
    perPageOptions: [10, 25, 50, 100]
}
